import React, {useState} from 'react';
import styled from 'styled-components';
import useBreakPoints from "../hooks/useBreakPoint";
import {Button, Col, Modal, Row, Typography, Image} from "antd";
import ContentContainer from "./ContentContainer";
import BannerImage from '../assets/imgs/banner_home.jpg';
import ShowAnimation from "./animations/ShowAnimation";
import PacienteIcon from "../assets/imgs/paciente.png";
import DonateImage from "../assets/imgs/donate.png";
import ApoiadorIcon from "../assets/imgs/apoiador.png";
import {useNavigate} from "react-router-dom";
import DotIcons from "./DotIcons";
import {GREE_1} from "../utils/colors";
import ImageBackground from "./ImageBackground";
import { ROUTES } from "../constants/PathRoutes";

const {Paragraph} = Typography;

const Container = styled.div`
  width: 100%;

  background: gray;

  position: relative;

  ${({isMdBreakPoint}) => {
    if (isMdBreakPoint) {
      return `
            height: 700px;
            padding-top: 180px;
        `
    }
    return `
              height: 500px;
            padding-top: 30px;
      
        `
  }}
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    z-index: 1;
  }
`

const TextContainer = styled.div`
  max-width: 600px;
  margin: 0 0 0 auto;
  position: relative;
    text-align: left;
  z-index: 1;
  text-shadow: 0px 0px 3px black;
    //background: red;
    padding-top: ${({isMdBreakPoint}) => isMdBreakPoint? '125px': '50px'};
`
const StyledImageButton = styled.img`
  height: 40px;
`


const StyledTitle = styled.h1`
  color: white !important;
  font-weight: 400;
  margin-top: 0;
  font-size: 32px;

  & span {
    font-size: 40px;
    font-weight: bold;
  }

`

const StyledParagraph = styled(Paragraph)`
  
  color: white !important;
  font-weight: bold;
  font-size: 20px;
`

const StyledButton = styled(Button)`
    font-weight: bold;
    font-size: 18px;
    height: 50px !important;
    display: flex;
    align-items: center;
    gap: 8px;

    background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%);
    border: none;
    color: #000;
    font-weight: bold;
    height: 32px;
    //padding: 0 20px;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(255, 215, 0, 0.3);
    transition: all 0.3s ease;

    &:hover {
        background: linear-gradient(135deg, #FFA500 0%, #FFD700 100%);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 215, 0, 0.5);
        color: #000;
    }
`
const StyledModal = styled(Modal)`
  font-weight: bold;
  font-size: 18px;
`


export default function Banner() {
    const {isMdBreakPoint} = useBreakPoints()
    const navigate = useNavigate()
    const [isModalDonateOpen, setIsModalDonateOpen] = useState(false);

    const showModal = () => {
        navigate(ROUTES.AREA_ASSOCIADO_CADASTRO)
    };


    return (

        <Container isMdBreakPoint={isMdBreakPoint}>
            <ImageBackground
                src={BannerImage}/>

            <ContentContainer>
                <TextContainer isMdBreakPoint={isMdBreakPoint}>

                    <ShowAnimation delay={0}>
                        <DotIcons style={{marginLeft: 'auto'}}/>
                        <StyledTitle><span>Bem-vindo </span>ao Centro de
                            Pesquisa e Estudos da Cannabis
                            Medicinal.</StyledTitle>
                    </ShowAnimation>
                    <ShowAnimation delay={0.5}>
                        <StyledParagraph
                            
                            // ellipsis={{rows: 4, expandable: false,}}
                            color={GREE_1}>Aqui cultivamos transformação: com pesquisa, acolhimento e justiça social, promovemos o acesso à saúde por meio da Cannabis Medicinal para construir uma sociedade sem preconceitos.</StyledParagraph>
                    </ShowAnimation>
                    <Row style={{marginTop: 24}} gutter={[16, 16]}>

                        <Col xs={24} md={12}>
                            <ShowAnimation delay={0.7}>

                                <StyledButton size={'large'} type={'primary'}
                                              block
                                              onClick={showModal}
                                              >Seja um Associado</StyledButton>
                            </ShowAnimation>
                        </Col>
                    </Row>

                </TextContainer>

            </ContentContainer>

            <StyledModal
                title="Você pode doar qualquer quantia para que possamos seguir ajudando nossos pacientes a ter acesso terapêutico de qualidade independentemente de sua condição econômica e social, ademais todos os nossos esforços e recursos são também utilizados no desenvolvendo pesquisas e parcerias em prol do uso medicinal da Cannabis e no desenvolvimento de outros fitofármacos oriundos de plantas da nossa caatinga."
                open={isModalDonateOpen}
                footer={null}
                width={1000}
                onCancel={() => {
                    setIsModalDonateOpen(false);
                }}>
                <Row gutter={[16,]}>
                    <Col xs={24}>
                        <Image width={'100%'} src={DonateImage}/>
                    </Col>

                </Row>
            </StyledModal>
        </Container>

    )
}
